import { Input } from 'antd';

export const SInput = Input;
